export const validateRequired = (setMsg = "この項目を入力してください") => {
  return { required: { value: true, message: setMsg } };
};
export const validateMaxlength = (length) => {
  return {
    maxLength: {
      value: length,
      message: `${length + 1}桁以上は入力できません`,
    },
  };
};
export const validateMinlength = (length) => {
  return {
    minLength: { value: length, message: `${length}桁以上で入力してください` },
  };
};
export const validateEmailAddress = () => {
  return {
    pattern: {
      value:
        /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
      message: "メールアドレス形式で入力してください",
    },
  };
};

export const validatePhoneWithoutHyphen = () => {
  return {
    pattern: {
      value: /^0\d{9,10}$/,
      message: "ハイフン無しの電話番号を入力してください",
    },
  };
};
export const validatePhoneWithHyphen = () => {
  return {
    pattern: {
      value: /^\d{2,4}-\d{2,4}-\d{4}$/,
      message: "電話番号を入力してください",
    },
  };
};

export const validateDateTime = () => {
  return {
    pattern: {
      value: /^\d{4,6}-\d{2}-\d{2}T\d{2}:\d{2}$/,
      message: "正しい日付と時刻の形式（YYYY-MM-DDTHH:MM）で入力してください",
    },
  };
};

export const validateNonNegInt = () => {
  return {
    pattern: {
      value: /^(0|[1-9]\d*)$/,
      message: "0または正の整数のみを入力してください",
    },
  };
};
export const validateNumber = () => {
  return {
    pattern: {
      value: /^[0-9]\d*$/,
      message: "半角数字のみを入力してください",
    },
  };
};
export const validateNumberOneOrMore = () => {
  return {
    pattern: {
      value: /^[1-9]\d*$/,
      message: "1以上の数値のみを入力してください",
    },
  };
};
export const validateHalfAlphaNum = () => {
  return {
    pattern: {
      value: /^([ -~])*$/,
      message: "半角英数字または半角記号を入力してください",
    },
  };
};
export const validatePostcode = () => {
  return {
    pattern: {
      value: /^[0-9]{3}-?[0-9]{4}$/,
      message: "郵便番号を入力してください",
    },
  };
};
export const validateUrl = () => {
  return {
    pattern: {
      value: /^https?:\/\/[\w/:%#$&?()~.=+-]+/,
      message: "URLを入力してください",
    },
  };
};
export const validateStudentId = () => {
  return {
    pattern: {
      value: /^[0-9]{8}$/,
      message: "数値8桁で入力してください",
    },
  };
};
export const validateGenerationId = () => {
  return {
    pattern: {
      value: /^[0-9]{4}$/,
      message: "数値4桁で入力してください",
    },
  };
};
export const validateStudentIdAlignment = (
  nameStudent,
  nameGeneration,
  itemText
) => {
  return {
    validate: (_, formValues) => {
      const stId = formValues[nameStudent].substring(0, 4);
      const genId = formValues[nameGeneration];

      if (stId !== genId) {
        return `${itemText}`;
      }
      return true;
    },
  };
};
export const validateConfirm = (name1, name2, itemText) => {
  return {
    validate: {
      confirmMail: (_, formValues) => {
        const val1 = formValues[name1];
        const val2 = formValues[name2];
        let result = true;
        if (val1 != val2) {
          if (!((val1 == null || val1 == "") && (val2 == null || val2 == ""))) {
            result = false;
          }
        }
        return result || `${itemText}が一致しません`;
      },
    },
  };
};
export const validateConfirmMail = () => {
  return validateConfirm("mail1", "mail2", "メールアドレス");
};
export const validateConfirmPassword = () => {
  return validateConfirm("password1", "password2", "パスワード");
};
export const validateDifferentVal = (name1, name2, itemText) => {
  return {
    validate: (_, formValues) => {
      if (
        formValues[name1] &&
        formValues[name2] &&
        formValues[name1] === formValues[name2]
      ) {
        return `${itemText}は別の内容を入力してください`;
      }
      return true;
    },
  };
};
export const validateFromToVal = (name1, name2, itemText) => {
  return {
    validate: (_, formValues) => {
      if (formValues[name1] > formValues[name2]) {
        return `${itemText}`;
      }
      return true;
    },
  };
};
